module.exports = __webpack_public_path__ + "static/media/cross-white.721a40f7.svg";